module.exports = __webpack_public_path__ + "img/calendar.1cf7ed37.png";